var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-md-120px",
    attrs: {
      "outlined": "",
      "small": "",
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.addField('text-employer');
      }
    }
  }, [_c('span', [_vm._v("고용주 입력란 추가")])])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-md-120px",
    attrs: {
      "outlined": "",
      "small": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addField('text-employee');
      }
    }
  }, [_c('span', [_vm._v("근로자 입력란 추가")])])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-md-120px",
    attrs: {
      "outlined": "",
      "small": "",
      "block": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.addField('check');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("체크박스 추가")])])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-md-120px",
    attrs: {
      "outlined": "",
      "small": "",
      "block": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.addField('canvas');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("서명 추가")])])], 1)], 1), _c('div', {
    staticClass: "scroll-primary mt-6 mt-lg-12"
  }, [_c('div', {
    staticClass: "pdfImg"
  }, [_vm.base64Url ? _c('v-img', {
    attrs: {
      "src": _vm.base64Url
    }
  }, _vm._l(_vm.fieldArr, function (field) {
    return _c('employment-form-field', {
      key: field.dataLabel,
      attrs: {
        "value": field,
        "page": _vm.pageNumber
      },
      on: {
        "close": _vm.close,
        "update": _vm.update
      }
    });
  }), 1) : _c('canvas', {
    attrs: {
      "id": "canvas-".concat(_vm.pageNumber)
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }